import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const QuizHeroCircle = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon {...rest} viewBox="0 0 48 48">
      <rect width="48" height="48" rx="24" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.625 15.8333C19.625 14.0614 21.0614 12.625 22.8333 12.625H25.1667C26.9386 12.625 28.375 14.0614 28.375 15.8333V18.1667C28.375 18.6499 27.9832 19.0417 27.5 19.0417H20.5C20.0168 19.0417 19.625 18.6499 19.625 18.1667V15.8333ZM22.8333 14.375C22.0279 14.375 21.375 15.0279 21.375 15.8333V17.2917H26.625V15.8333C26.625 15.0279 25.9721 14.375 25.1667 14.375H22.8333Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5681 15.7502C17.7156 15.6795 17.8793 15.7921 17.879 15.9556L17.875 18.1667C17.875 19.6164 19.0503 20.7917 20.5 20.7917H27.5C28.9497 20.7917 30.125 19.6164 30.125 18.1667V15.955C30.125 15.7916 30.2886 15.6793 30.436 15.75C31.8186 16.4128 32.75 17.8246 32.75 19.433V31.6707C32.75 33.6666 31.2633 35.3499 29.2827 35.5966C25.7745 36.0335 22.2255 36.0335 18.7173 35.5966C16.7367 35.3499 15.25 33.6666 15.25 31.6707V19.433C15.25 17.8248 16.1852 16.4132 17.5681 15.7502ZM27.5 24C27.9832 24 28.375 24.3918 28.375 24.875C28.375 25.3582 27.9832 25.75 27.5 25.75H20.5C20.0168 25.75 19.625 25.3582 19.625 24.875C19.625 24.3918 20.0168 24 20.5 24H27.5ZM26.3333 27.5C26.8166 27.5 27.2083 27.8918 27.2083 28.375C27.2083 28.8582 26.8166 29.25 26.3333 29.25H20.5C20.0168 29.25 19.625 28.8582 19.625 28.375C19.625 27.8918 20.0168 27.5 20.5 27.5H26.3333Z"
        fill="white"
      />
    </StyledIcon>
  );
};

QuizHeroCircle.propTypes = {
  color: PropTypes.string
};

QuizHeroCircle.defaultProps = {
  color: 'var(--color-i-green)'
};

export default QuizHeroCircle;
